import { Pill } from "@mantine/core";
import React from "react";

const STATUS_COLORS = {
  PENDING: "red.5",
  IN_PROGRESS: "orange.7",
  COMPLETED: "primary.7",
  ESCALATED: "orange.7",
};

const STATUS_TEXT = {
  PENDING: "Pending",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  ESCALATED: "Escalated",
};

const StatusPill = ({ status }) => {
  return (
    <Pill radius="xs" fz="sm" c="white" bg={STATUS_COLORS[status] || "gray.7"}>
      {STATUS_TEXT[status] || status}
    </Pill>
  );
};

export default StatusPill;
